import React, { useState } from "react"
import {
  Card,
  CardImg,
  CardBody,
  CardTitle,
  CardSubtitle,
  Form,
  FormGroup,
  FormText,
  Label,
  Input,
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Spinner,
} from "reactstrap"
import { Link } from "react-router-dom"
import { Auth } from "aws-amplify"
import { redirectTo } from "../../../utils/routes.utils"
import { queryClient } from "../../../utils/functions.utils"
import logo from "../../../assets/images/logo.png"
import { signIn, updateEmailVerificationStatus } from "../../../utils/auth.utils"
import Users from "../../../utils/apis/users"
import { emailPattern } from "../../../utils/form.utils"
import VerifyEmail from "../SignUp/VerifyEmail"
import SpinnerOverlay from "../../SpinnerOverlay"
import "../authPages.scss"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faEye, faEyeSlash } from "@fortawesome/free-solid-svg-icons"

const SignIn = (props) => {
  const isDemo = new URLSearchParams(window.location.search).get("demo") === "1" ? true : false,
    [email, setEmail] = useState(isDemo ? "demo@billgist.com" : ""),
    [password, setPassword] = useState(isDemo ? "DemoBillgist" : ""),
    [newPassword, setNewPassword] = useState(""),
    [user, setUser] = useState({}),
    [modal, setModal] = useState(false),
    [loading, setLoading] = useState({
      signIn: false,
      resetPassword: false,
    }),
    [error, setError] = useState(""),
    [isModalOpen, setIsModalOpen] = useState(false),
    [showPasswordIcon, setPasswordIcon] = useState(false)

  const handleSignIn = async (event) => {
    event.preventDefault()
    setLoading({ ...loading, signIn: true })
    try {
      if (emailPattern.test(email) === false) {
        throw Error("Invalid email!")
      }
      if (password.length < 10) {
        throw Error("Password must have at least 10 characters!")
      }
      error && setError("")
      const userInfo = await signIn({ email, password })
      if (userInfo.challengeName === "NEW_PASSWORD_REQUIRED") {
        setUser(userInfo)
        setModal(true)
      } else {
        queryClient.invalidateQueries({ queryKey: ["useAuthStatus"] })
        return redirectTo(props, "/dashboard")
      }
    } catch (error) {
      if (error.name === "UserNotConfirmedException") {
        setIsModalOpen(!isModalOpen)
      } else {
        setError(error.message)
        setLoading({ ...loading, signIn: false })
      }
    }
  }

  const handleResetPasswordSubmit = async (event) => {
    event.preventDefault()
    setLoading({ ...loading, resetPassword: true })
    try {
      if (password.length >= 10) {
        await Auth.completeNewPassword(user, newPassword)
        await Users.update({ item_id: user.username, verify_email: true })
        await updateEmailVerificationStatus(true)
        queryClient.invalidateQueries({ queryKey: ["useAuthStatus"] })
        setLoading({ ...loading, resetPassword: false })
        return redirectTo(props, "/dashboard")
      }
    } catch (error) {
      setError(error.message)
      setLoading({ ...loading, resetPassword: false })
    }
  }

  const toggle = () => setModal(!modal)

  const onChangeHandler = (event) => {
    const { name, value } = event.target
    name === "email" ? setEmail(value) : name === "password" ? setPassword(value) : setNewPassword(value)
  }

  return (
    <div className="d-flex justify-content-center align-items-center full-height bg-primary auth-page-container">
      <Card className="p-2 my-5 mx-1 auth-card-container bg-light">
        <Link to="/" className="align-self-center mt-4 mb-4">
          <CardImg className="h-auto auth-card-img" top src={logo} alt="logo" />
        </Link>
        <CardTitle className="fw-bold align-self-center auth-card-title text-secondary">SIGN IN</CardTitle>
        <div className="align-self-center text-center error">
          {error ? (
            <CardSubtitle data-testid="error" className="text-danger">
              {error}
            </CardSubtitle>
          ) : null}
        </div>
        <CardBody className="align-self-center mx-5 py-0 auth-card-body">
          <Form onSubmit={handleSignIn} className="d-flex flex-column">
            <FormGroup>
              <Label for="email" className="fw-bold auth-input-label text-dark">
                EMAIL <span>*</span>
              </Label>
              <Input
                type="email"
                name="email"
                id="email"
                value={email}
                className="rounded text-secondary"
                placeholder="e.g. example@domain.com"
                onChange={onChangeHandler}
                required
                autoFocus
              />
            </FormGroup>
            <FormGroup className="position-relative">
              <Label for="password" className="fw-bold auth-input-label text-dark">
                PASSWORD <span>*</span>
              </Label>
              <Input
                type={showPasswordIcon ? "text" : "password"}
                data-testid="password"
                name="password"
                id="password"
                value={password}
                className="rounded text-secondary"
                onChange={onChangeHandler}
                minLength="10"
                required
              />
              <FontAwesomeIcon
                icon={showPasswordIcon ? faEye : faEyeSlash}
                className="position-absolute text-muted password-icon"
                onClick={() => {
                  setPasswordIcon(!showPasswordIcon)
                }}
              />
              <FormText color="muted">Must have at least 10 characters</FormText>
            </FormGroup>
            <Link to="/sign-in/reset">Forgot password?</Link>
            <Button
              type="submit"
              color="primary"
              disabled={loading.signIn}
              className="mt-4 p-2 text-white rounded"
              block
            >
              SIGN IN
            </Button>
            <p className="text-center mt-4">
              Don&apos;t have an account?
              <Link to="/sign-up" className="ms-1 fw-bold text-link">
                Sign Up
              </Link>
            </p>
          </Form>
        </CardBody>
      </Card>
      <Modal isOpen={user.challengeName === "NEW_PASSWORD_REQUIRED"} toggle={toggle}>
        <ModalHeader>Reset password</ModalHeader>
        {error ? <div className="align-self-center mt-2 text-danger">{error}</div> : null}
        <Form onSubmit={handleResetPasswordSubmit} className="d-flex flex-column">
          <ModalBody>
            <FormGroup className="my-4">
              <Label for="newPassword" className="input_label fw-bold text-muted">
                PASSWORD
              </Label>
              <FormText className="d-flex text-muted mb-1">Password must have at least 10 characters.</FormText>
              <Input
                type="password"
                name="newPassword"
                id="newPassword"
                placeholder="New Password"
                onChange={onChangeHandler}
                required
              />
            </FormGroup>
          </ModalBody>
          <ModalFooter>
            <Button type="submit" className="signin_btn fw-bold align-self-center">
              {loading.resetPassword ? <Spinner size="sm" className="signin_spinner m-1" /> : null}
              SAVE
            </Button>
          </ModalFooter>
        </Form>
      </Modal>
      <VerifyEmail isModalOpen={isModalOpen} formData={{ email, password }} />
      <SpinnerOverlay show={loading.signIn} />
    </div>
  )
}

export default SignIn
